module.exports = __webpack_public_path__ + "img/8.960f2560.jpg";